export default {
    publicKey: '6Lck2qYZAAAAAMMfLb2EQo5TiwGS4zG8LwI7sABN',
    hl: 'ru',
    notValid: 'Вы не прошли валидацию reCAPTCHA. Попробуйте еще раз.',
};
